import { Fragment, useEffect, useState } from "react";
import { backend_api_url, getUserSessionData, isUserAdmin } from "./constants";

const ActionsContainer = (props: any) => {
 

	useEffect(() => {
		 
        if(!isUserAdmin()) {
            window.location.href = '/';
        } 
	  }, []);

      props.setClassInfo("accountPg");

    return (
        <Fragment>
            <div className="contents">
               <a href="/admin/users">Users</a>&nbsp;|&nbsp;               
               <a href="/admin/creators">Creators</a>&nbsp;|&nbsp;               
               <a href="/admin/collections">Collections</a>&nbsp;|&nbsp;               
               Purchases: <a href="/admin/purchases/credits">Credits</a>&nbsp;-&nbsp;<a href="/admin/purchases/nfts">NFTs</a>&nbsp;|&nbsp;
               <a href="/admin/actions">Actions</a>

                <br /><br /><br />
               <div>
                    <a target="_blank" href="/admin/adjust-credits">Adjust Credits</a>
                    <br />
                    <a target="_blank" href="/admin/promo-codes">Promo Codes</a>
                </div> 
            </div>
                
         
        </Fragment>
    );
}

export default ActionsContainer;